import DateUtils from "@date-io/date-fns";
import {
	Checkbox,
	FormControlLabel,
	FormGroup,
	TextField,
} from "@material-ui/core";
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import React, { forwardRef } from "react";

const OrcamentoBaseTroca = forwardRef((props, ref) => {
	const handleChange = (event) => {
		props.SetOrcamentoExtras({
			...props.orcamentoExtras,
			[event.target.name]: event.target.checked,
			baseTrocaProdutos: event.target.checked
				? props.orcamentoExtras.baseTrocaProdutos
				: "",
			baseTrocaValor: event.target.checked
				? props.orcamentoExtras.baseTrocaValor
				: "",
		});
	};

	return (
		<div className="p-1">
			<FormGroup>
				<FormControlLabel
					control={
						<Checkbox
							checked={props.orcamentoExtras.baseTroca}
							onChange={handleChange}
							name="baseTroca"
							color="primary"
						/>
					}
					label="É um orçamento a base de troca?"
				/>
			</FormGroup>
			{props.orcamentoExtras.baseTroca && (
				<>
					<FormGroup>
						<TextField
							id="baseTrocaProdutos"
							label="Lista dos produtos"
							type="text"
							autoComplete={"off"}
							size="small"
							multiline
							error={props.orcamentoExtras.baseTrocaProdutos === ""}
							value={
								props.orcamentoExtras
									? props.orcamentoExtras.baseTrocaProdutos
									: ""
							}
							onChange={(e) =>
								props.SetOrcamentoExtras({
									...props.orcamentoExtras,
									baseTrocaProdutos: e.target.value,
								})
							}
							helperText={
								"Quais produtos o cliente irá enviar para a MetaLife?"
							}
							autoFocus
						/>
					</FormGroup>
					<FormGroup>
						<TextField
							id="baseTrocaValor"
							label="Valor dos produtos"
							type="Number"
							autoComplete={"off"}
							size="small"
							error={props.orcamentoExtras.baseTrocaValor === ""}
							value={
								props.orcamentoExtras
									? props.orcamentoExtras.baseTrocaValor
									: ""
							}
							onChange={(e) =>
								props.SetOrcamentoExtras({
									...props.orcamentoExtras,
									baseTrocaValor: e.target.value,
								})
							}
							helperText={
								"Qual o valor do desconto referente a esses produtos?"
							}
						/>
					</FormGroup>
					<FormGroup>
						<TextField
							id="cNFConsignadoOriginal"
							label="Numero da nota fical"
							type="text"
							autoComplete={"off"}
							size="small"
							error={
								props.orcamentoExtras.cNFConsignadoOriginal === "" ||
								props.orcamentoExtras.cNFConsignadoOriginal.toString()
									.length !== 9
							}
							value={
								props.orcamentoExtras
									? props.orcamentoExtras.cNFConsignadoOriginal
									: ""
							}
							onChange={(e) =>
								props.SetOrcamentoExtras({
									...props.orcamentoExtras,
									cNFConsignadoOriginal: e.target.value,
								})
							}
							helperText={"Tem que ter 9 numeros."}
						/>
					</FormGroup>
					<MuiPickersUtilsProvider utils={DateUtils}>
						<KeyboardDatePicker
							fullWidth
							autoOk
							variant="dialog"
							margin="normal"
							format="dd/MM/yyyy"
							id="date-picker-inline"
							label="Data de emissão"
							autoComplete={"off"}
							value={
								props.orcamentoExtras.dNFConsignadoEmissao
									? props.orcamentoExtras.dNFConsignadoEmissao
									: ""
							}
							error={props.orcamentoExtras.dNFConsignadoEmissao === ""}
							onChange={(e) =>
								props.SetOrcamentoExtras({
									...props.orcamentoExtras,
									dNFConsignadoEmissao: e,
								})
							}
						/>
					</MuiPickersUtilsProvider>
					<FormGroup>
						<TextField
							id="nValorEntrada"
							label="Valor de entrada"
							type="Number"
							autoComplete={"off"}
							size="small"
							error={
								props.orcamentoExtras.nValorEntrada === "" ||
								props.orcamentoExtras.nValorEntrada < 1
							}
							value={
								props.orcamentoExtras ? props.orcamentoExtras.nValorEntrada : ""
							}
							onChange={(e) =>
								props.SetOrcamentoExtras({
									...props.orcamentoExtras,
									nValorEntrada: e.target.value,
								})
							}
							helperText={"Tem que ser maior que 0."}
						/>
					</FormGroup>
				</>
			)}
		</div>
	);
});

export default OrcamentoBaseTroca;
